import fr from 'facet-rest';
import BaseOverride from './BaseOverride';

const DetailListOverride = fr.metaOverride({ base: BaseOverride });

export default DetailListOverride;
